import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { AppLoadingScreen } from '~/components/app-loading-screen';
import { authClient } from '~/lib/auth-client';
import { getPostHog } from '~/lib/posthog';
import { useTRPC } from '~/lib/trpc';
import { pauseBrowserPushSession } from '~/notifications/use-browser-push-session';

export const Route = createFileRoute('/sign-out')({
  component: SignOutPage,
});

function SignOutPage() {
  const trpc = useTRPC();
  const { mutateAsync: pauseSms } = useMutation(
    trpc.notifications.subscriptions.pauseSms.mutationOptions(),
  );

  useEffect(() => {
    void pauseBrowserPushSession(pauseSms)
      .catch(() => null)
      .then(() => authClient.signOut())
      .catch(() => null)
      .then(() => {
        getPostHog()?.reset();
        window.location.replace('/sign-in');
      });
  }, [pauseSms]);

  return <AppLoadingScreen />;
}
